import { IntlShape } from 'react-intl';
import { messages } from './messages';
import { StatusOptionsType } from './types';

export const options = (intl: IntlShape): StatusOptionsType[] => [
  {
    label: `${intl.formatMessage(messages.pending)}`,
    value: `${intl.formatMessage(messages.pending)}`
  },
  {
    label: `${intl.formatMessage(messages.settled)}`,
    value: `${intl.formatMessage(messages.settled)}`
  },
  {
    label: `${intl.formatMessage(messages.voided)}`,
    value: `${intl.formatMessage(messages.voided)}`
  },
  {
    label: `${intl.formatMessage(messages.reconciled)}`,
    value: `${intl.formatMessage(messages.reconciled)}`
  }
];
